// API configuration for production and local development
const getApiBaseUrl = () => {
  // If running in browser on localhost or 127.0.0.1, always connect to local backend
  if (typeof window !== 'undefined' && window.location) {
    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1') {
      return 'http://localhost:8080';
    }
  }

  // Production or explicit environment variable
  return (
    process.env.REACT_APP_API_BASE_URL ||
    'https://tahanazir-001-site6.gtempurl.com'
  );
};

export const API_BASE_URL = getApiBaseUrl();

export const API_ENDPOINTS = {
  // User endpoints
  users: `${API_BASE_URL}/api/users`,
  login: `${API_BASE_URL}/api/users/login`,
  register: `${API_BASE_URL}/api/users/add`,

  // Course endpoints
  courses: `${API_BASE_URL}/api/courses`,

  // Learning endpoints
  learning: `${API_BASE_URL}/api/learning`,

  // Assessment endpoints
  assessments: `${API_BASE_URL}/api/assessments`,

  // Discussion endpoints
  discussions: `${API_BASE_URL}/api/discussions`,

  // Feedback endpoints
  feedbacks: `${API_BASE_URL}/api/feedbacks`,

  // Questions endpoints
  questions: `${API_BASE_URL}/api/questions`,

  // Progress endpoints
  progress: `${API_BASE_URL}/api/progress`,

  // Chatbot endpoints
  chatbot: `${API_BASE_URL}/api/chatbot`,

  // Admins endpoints
  admins: `${API_BASE_URL}/api/admins`,

  // Registration Requests endpoints
  registrations: `${API_BASE_URL}/api/registrations`,

  // Categories endpoints
  categories: `${API_BASE_URL}/api/categories`
};

console.log('API Base URL:', API_BASE_URL);